(function () {
  const initTabsWithProducts = () => {
    const tabsParent = $(".tabs-with-text");
    const tabs = tabsParent.find(".twt__tabs-item");

    tabs.on("click", function () {
      const tabsContent = $(this)
        .closest(".twt__tabs")
        .next()
        .find(".twt__content-item");

      if (!$(this).is("[data-active]")) {
        $(this).parent().find("[data-active]").removeAttr("data-active");
        $(this).attr("data-active", "");
        tabsContent
          .hide()
          .eq($(this).index())
          .fadeIn(300)
          .css("display", "flex");
      }
    });

    // Скрываем навигацию — она больше не нужна
    tabsParent.each(function (index, elem) {
      const nav = elem.querySelector(".twt__nav");
      if (nav) nav.style.display = "none";
    });
  };

  const initSection = () => {
    initTabsWithProducts();
  };

  initSection();

  document.addEventListener("shopify:section:load", function () {
    initSection();
  });
})();